module.exports = __webpack_public_path__ + "img/client_no_active.a82807a6.svg";